var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import CryptoJS from 'crypto-js';
import { prism } from './lib/prism.cls';
import * as prismStoreExtensions from './provider/candle-history';
var state = __assign({}, prismStoreExtensions.stateExt);
var actions = __assign({}, prismStoreExtensions.actionsExt);
var mutations = __assign({}, prismStoreExtensions.mutationsExt);
var getters = __assign({}, prismStoreExtensions.gettersExt);
var prismStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var prismMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[prism.STORE_MODULE_NAME])) {
            this.$store.registerModule(prism.STORE_MODULE_NAME, prismStore);
        }
    },
    methods: __assign(__assign({}, mapActions({
        _runCheckAccountDetail: Const.RUN_CHECK_ACCOUNT_DETAIL,
        _runDasboardStatsDetail: Const.RUN_CHECK_DASHBOARD_STATS,
        _runUserPanAttepmtNameApi: Const.RUN_USER_PAN_ATTEMPT_NAME_API,
        _runUserPanAttepmtDigitapApi: Const.RUN_USER_PAN_ATTEMPT_DIGITAP_API,
        _runUserFunc: Const.RUN_USER_FUNCTION,
        _runBackstagedTicket: Const.RUN_BAKSTAGED_TICKET,
        _runAddGeoLocation: Const.RUN_ADD_GEOLOCATION,
        _runGetBankInformationInDetail: Const.RUN_GET_BANK_INFORMATION_IN_DETAIL,
        _runMarginPledgeSuccessIsin: Const.RUN_MARGIN_PLEDGE_SUCCESS_ISIN,
        _runMarginPledgeRequestDetail: Const.RUN_MARGIN_PLEDGE_REQUEST_DETAIL,
        _runKSoftProfileApi: Const.RUN_KSOFT_PROFILE_API,
        _runPledgeApprovedIsins: Const.RUN_PLEDGE_APPROVED_ISINS,
        _runMarginPledgeRequest: Const.RUN_MARGIN_PLEDGE_REQUEST,
        //-------------------------------------------add--------------------------------------------
        _runAddData: Const.RUN_ADD_DATA,
        _runSubmitConsent: Const.RUN_SUBMIT_CONSENT,
        _runAggregatorData: Const.RUN_AGGREGATOR_DATA,
        _runResendOtpData: Const.RUN_RESEND_OTP_DATA,
        _runAddOtpData: Const.RUN_ADD_OTP_DATA,
        _runGetPcrLedgerData: Const.RUN_GET_PCR_LEDGER_DATA,
        //-------------------------------------------listing----------------------------------------
        _runGetListingData: Const.RUN_GET_LISTING_DATA,
        //-------------------------------------------view-------------------------------------------
        _runViewSupportDetail: Const.RUN_VIEW_SUPPORT_DETAIL,
        //=====================================funds===============================================
        _runGetMandateList: Const.RUN_GET_MANDATE_LIST,
        _runGetPortfolioList: Const.RUN_GET_PORTFOLIO_LIST,
        //-------------------------------------------dropdown---------------------------------------
        _runGetSupportReasonList: Const.RUN_GET_SUPPORT_REASON_LIST,
        _runGetUserLeverage: Const.RUN_GET_CURRENT_LEVERAGE,
        _runConfirmUpdateData: Const.RUN_CONFIRM_UPDATE_DATA,
        _runAddProfileImageData: Const.RUN_ADD_PROFILE_IMAGE_DATA,
        _runAddProfileImageDataFromProfile: Const.RUN_ADD_PROFILE_IMAGE_DATA_FROM_PROFILE,
        _runGetPlatformList: Const.RUN_GET_PLATFORM_LIST,
        _runGetOpenTicketReason: Const.RUN_GET_REASON_WISE_TICKET,
        _runMcxNcdex: Const.RUN_MCX_NCDEX,
        _rungetCategorization: Const.RUN_GET_CATEGORIZATION,
        _rungetCategorization2: Const.RUN_GET_CATEGORIZATION2,
        _runGetCategorizationApi: Const.RUN_GET_CATEGORIZATION_API,
        _runCreateMandate: Const.RUN_CREATE_MANDATE,
        _runPortfolioPay: Const.RUN_PORTFOLIO_PAY,
        _runGetIBList: Const.RUN_GET_IB_LIST,
        //=======================counpon module======================================================
        _runGetCouponList: Const.RUN_GET_COUPON_LIST,
        _runCouponScratch: Const.RUN_COUPON_SCRATCH,
        _runCouponReedem: Const.RUN_COUPON_REEDEM,
        _runCouponReferallMutualFund: Const.RUN_COUPON_REFERALL_MUTUAL_FUND,
        _runGetMFChartData: Const.RUN_GET_MF_CHART_DATA,
        _runGetCatalogProductlist: Const.RUN_GET_CATALOG_PRODUCT_LIST,
        _runGetBalance: Const.RUN_GET_CHECK_BALANCE,
        _runCreateOrder: Const.RUN_CREATE_ORDER,
        _runGetOrderHistoryList: Const.RUN_GET_ORDER_HISTORY_LIST,
        _runCheckOrderStatus: Const.RUN_CHECK_ORDER_STATUS,
        _runOrderResend: Const.RUN_ORDER_RESEND,
        _runrefundBalance: Const.RUN_REFUND_BALANCE,
        //====================referal coupon=====================================================
        _runGetCouponslist: Const.RUN_GET_COUPONS_LIST,
        _runGetBalanceAmount: Const.RUN_GET_BALANCE_AMOUNT,
        _runCreateCouponOrder: Const.RUN_CREATE_COUPON_ORDER,
        _runGetCouponOrderHistoryList: Const.RUN_GET_COUPON_ORDER_HISTORY_LIST,
        _runCheckCouponOrderStatus: Const.RUN_CHECK_COUPON_ORDER_STATUS,
        _runCouponOrderResend: Const.RUN_COUPON_ORDER_RESEND,
        //============================api key===============================================
        _runGetGenerateApiKey: Const.RUN_GET_GENERATE_API_KEY,
        _runGetApiKeyDetail: Const.RUN_GET_API_KEY_DETAIL,
        //===========================change password============================================================
        _runChangePassword: Const.RUN_CHANGE_PASSWORD,
        //===========================nominee data============================================================
        _runGetClientNomineeData: Const.RUN_GET_CLIENT_NOMINEE_DATA,
        //==========================hdfc transactions==============================
        _runHdfcTransactions: Const.GET_HDFC_TRANSACTION_LIST,
    })), { getdocviewfunc: function (getData, getPage) {
            var url = '', returnData = '';
            if (getPage == 'ticket_view') {
                if (parseInt(getData.reason) == 17) {
                    returnData = this.encryptResData('type=user&doc=' + getData.document + '&id=' + getData.person_id + '&signed=0' + '&auth=' + this.get_user.token);
                }
                else {
                    returnData = this.encryptResData('type=ticket&doc=' + getData.document + '&id=' + getData.person_id + '&auth=' + this.get_user.token);
                }
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'ticket_thread') {
                if (parseInt(getData.reason) == 14) {
                    returnData = this.encryptResData('type=user&doc=' + getData.document + '&id=' + getData.person_id + '&reqtype=' + getData.reqtype + '&signed=1' + '&auth=' + this.get_user.token);
                }
                else {
                    returnData = this.encryptResData('type=pdfdoc&doc=' + getData.document + '&id=' + getData.person_id + '&reqtype=' + getData.reqtype + '&signed=1' + '&auth=' + this.get_user.token);
                }
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'ticket_modification_doc') {
                returnData = this.encryptResData('type=pdfdoc&doc=' + getData.document + '&id=' + getData.id + '&reqtype=' + getData.reqtype + '&signed=0' + '&auth=' + this.get_user.token);
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'ticket_kyc') {
                if (parseInt(getData.reason) == 13 || parseInt(getData.reason) == 14) {
                    returnData = this.encryptResData('type=user&doc=' + getData.document + '&id=' + getData.id + '&reqtype=' + getData.reqtype + '&signed=' + getData.signed + '&auth=' + this.get_user.token);
                }
                else {
                    returnData = this.encryptResData('type=pdfdoc&doc=' + getData.document + '&id=' + getData.id + '&reqtype=' + getData.reqtype + '&signed=' + getData.signed + '&auth=' + this.get_user.token);
                }
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'profile') {
                returnData = this.encryptResData('type=user&doc=' + getData.passport_image + '&id=' + getData.id + '&signed=0&profile=1' + '&auth=' + this.get_user.token);
                url = this.doc_url_DEL + returnData;
                return url;
            }
            else if (getPage == 'profile_docs') {
                console.log('innnnnn profile_docs', getData.document);
                returnData = this.encryptResData('type=user&doc=' + getData.document + '&id=' + getData.id + '&signed=0' + '&auth=' + this.get_user.token);
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'profile_kyc') {
                returnData = this.encryptResData('type=user&doc=' + getData.document + '&id=' + getData.id + '&signed=' + getData.signed + '&auth=' + this.get_user.token);
                url = this.doc_url_DEL + returnData;
                return url;
            }
            else if (getPage == 'profile_ticket') {
                returnData = this.encryptResData('type=ticket&doc=' + getData.document + '&id=' + getData.id + '&auth=' + this.get_user.token);
                url = this.doc_url_DEL + returnData;
                window.open(url, '_blank');
            }
            else if (getPage == 'contract_notes') {
                returnData = this.encryptResData('type=contract&doc=' + getData.document + '&id=' + getData.id + '&exchange=' + getData.exchange + '&folder=' + getData.folder + '&auth=' + this.get_user.token);
                url = this.contract_note_document_url_DEL + returnData;
                window.open(url, '_blank');
            }
        }, encryptResData: function (plainText) {
            try {
                plainText += '&reqtime=' + Math.floor(Date.now() / 1000);
                plainText = plainText.toString();
                var ENC_KEY = "uzz0ffo4szq3vj2e37mq3wyesthhkp6y";
                var IV = "";
                var cipher = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(ENC_KEY), {
                    iv: CryptoJS.enc.Utf8.parse(IV),
                    padding: CryptoJS.pad.Pkcs7,
                    mode: CryptoJS.mode.CBC
                }).toString();
                cipher = cipher.replaceAll("+", "finv");
                return cipher;
            }
            catch (ex) {
                return "INVALID DECRYPT REQUEST";
            }
        }, readOnlyFunc: function (getData, reqFields) {
            console.log(this.get_user.profile.entered_manually, getData, reqFields);
            if (parseInt(this.get_user.profile.entered_manually) == 0 && getData != '' && getData != ' ' && getData != null && getData != undefined && reqFields == 'true') {
                return true;
            }
            else {
                return false;
            }
        }, back_fun_rout: function (getstep) {
            if (getstep == 1.5) {
                this.$router.replace('/Users/register/step1-5');
            }
            else {
                var step = parseInt(getstep) - 1;
                this.$router.replace('/Users/register/step' + step);
            }
        }, next_fun_rout: function (getstep) {
            var step = parseInt(getstep) + 1;
            this.$router.replace('/Users/register/step' + step);
        }, cleanStore: function () {
            this.$store.commit(Const.SET_COMPLAINT_OTP_VIEW_DATA, []);
        }, numberWithCommas: function (x) {
            if (x == undefined) {
                x = 0;
            }
            var negative = "";
            if (x < 0) {
                negative = '-';
            }
            x = parseFloat(x).toFixed(2);
            x = Math.abs(x);
            x = x.toString();
            var afterPoint = '';
            if (x.indexOf('.') > 0)
                afterPoint = x.substring(x.indexOf('.'), x.length);
            x = Math.floor(x);
            x = x.toString();
            var lastThree = x.substring(x.length - 3);
            var otherNumbers = x.substring(0, x.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            return negative + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
        } }),
    computed: {
        doc_url_DEL: function () {
            try {
                return this.$store.getters[Const.GET_DOCUMENT_URL_DEL];
            }
            catch (ex) {
                return [];
            }
        },
        contract_note_document_url_DEL: function () {
            try {
                return this.$store.getters[Const.GET_CONTRACT_NOTE_DOCUMENT_URL_DEL];
            }
            catch (ex) {
                return [];
            }
        },
        //=========================== tax-report====================================
        tax_report_list: function () {
            try {
                return this.$store.getters[Const.GET_TAX_REPORT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        ksoft_tax_report_list: function () {
            try {
                return this.$store.getters[Const.GET_KSOFT_TAX_REPORT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        ksoftProfileData: function () {
            try {
                return this.$store.getters[Const.GET_KSOFT_PROFILE_API];
            }
            catch (ex) {
                return [];
            }
        },
        financial_ledger_list1: function () {
            try {
                return this.$store.getters[Const.GET_FINANCIAL_LEDGER_LIST1];
            }
            catch (ex) {
                return [];
            }
        },
        tax_report: function () {
            try {
                return this.$store.getters[Const.GET_TAX_REPORT_LIST1];
            }
            catch (ex) {
                return [];
            }
        },
        bankInformationInDetail: function () {
            try {
                return this.$store.getters[Const.GET_BANK_INFORMATION_IN_DETAIL];
            }
            catch (ex) {
                return [];
            }
        },
        marginPledgeSuccessIsin: function () {
            try {
                return this.$store.getters[Const.GET_MARGIN_PLEDGE_SUCCESS_ISIN];
            }
            catch (ex) {
                return [];
            }
        },
        //=============================================================================
        getHoldingSum: function () {
            try {
                var holding_sum = 0;
                if (this.position_holding_order_list.Holdings.length > 0) {
                    for (var i = 0; i <= this.position_holding_order_list.Holdings.length - 1; i++) {
                        holding_sum += parseFloat(this.position_holding_order_list.Holdings[i].Value);
                        if (this.position_holding_order_list.Holdings.length - 1 == i) {
                            return holding_sum;
                        }
                    }
                }
                else {
                    return holding_sum;
                }
            }
            catch (err) {
                return 0;
            }
        },
        ksoftGetHoldingSum: function () {
            try {
                var holding_sum = 0;
                if (this.ksoft_position_holding_order_list.Holdings.length > 0) {
                    for (var i = 0; i <= this.ksoft_position_holding_order_list.Holdings.length - 1; i++) {
                        holding_sum += parseFloat(this.ksoft_position_holding_order_list.Holdings[i].Value);
                        if (this.ksoft_position_holding_order_list.Holdings.length - 1 == i) {
                            return holding_sum;
                        }
                    }
                }
                else {
                    return holding_sum;
                }
            }
            catch (err) {
                return 0;
            }
        },
        pledge_approved_isin: function () {
            try {
                return this.$store.getters[Const.GET_PLEDGE_APPROVED_ISINS];
            }
            catch (ex) {
                return [];
            }
        },
        //-----------------------referal coupons-------------------------------------------------------
        Couponslist: function () {
            try {
                return this.$store.getters[Const.GET_COUPONS_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        Availablebalance: function () {
            try {
                return this.$store.getters[Const.GET_BALANCE_AMOUNT];
            }
            catch (ex) {
                return [];
            }
        },
        OrderHistoryList: function () {
            try {
                return this.$store.getters[Const.GET_COUPON_ORDER_HISTORY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        cart_list: function () {
            try {
                return this.$store.getters[Const.GET_COUPON_CART_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        pendingbalance: function () {
            try {
                return this.$store.getters[Const.GET_PENDING_BALANCE];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------listing--------------------------------------------
        product_list: function () {
            try {
                return this.$store.getters[Const.GET_CATALOG_PRODUCT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        product_balance: function () {
            try {
                return this.$store.getters[Const.GET_CHECK_BALANCE];
            }
            catch (ex) {
                return [];
            }
        },
        order_history: function () {
            try {
                return this.$store.getters[Const.GET_ORDER_HISTORY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        xml_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_XML_DOC_URL];
            }
            catch (ex) {
                return [];
            }
        },
        mf_chart_data: function () {
            try {
                return this.$store.getters[Const.GET_MF_CHART_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        get_user: function () {
            try {
                return this.$store.getters[Types.GET_USER];
            }
            catch (ex) {
                return [];
            }
        },
        get_leverage: function () {
            try {
                return this.$store.getters[Const.GET_CURRENT_LEVERAGE];
            }
            catch (ex) {
                return [];
            }
        },
        pcr_list: function () {
            try {
                return this.$store.getters[Const.GET_PCR_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        user_profile: function () {
            try {
                return this.$store.getters[Types.GET_USER];
            }
            catch (ex) {
                return [];
            }
        },
        PCodeEnabled: function () {
            try {
                return this.$store.getters['GET_USER'].profile.pcode.split(",");
            }
            catch (ex) {
                return [];
            }
        },
        position_holding_order_list: function () {
            try {
                return this.$store.getters[Const.GET_POSITION_HOLDING_ORDER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        ksoft_position_holding_order_list: function () {
            try {
                return this.$store.getters[Const.GET_POSITION_KSOFT_HOLDING_ORDER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        close_position_list: function () {
            try {
                return this.$store.getters[Const.GET_CLOSE_POSITION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        margin_info_list: function () {
            try {
                return this.$store.getters[Const.GET_MARGIN_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        profile_list: function () {
            try {
                return this.$store.getters[Const.GET_PROFILE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        dashboard_stats_sm: function () {
            try {
                return this.$store.getters[Const.GET_DASHBOARDSTATS];
            }
            catch (ex) {
                return [];
            }
        },
        support_list: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        deposit_list: function () {
            try {
                return this.$store.getters[Const.GET_DEPOSIT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        financial_ledger_list: function () {
            try {
                //=================download file code============================================
                // sort array as per requirement
                var financial_array = [];
                var getData = this.$store.getters[Const.GET_FINANCIAL_LEDGER_LIST];
                for (var i = 0; i <= getData.length - 1; i++) {
                    for (var j = 0; j <= getData[i].details.length - 1; j++) {
                        financial_array.push(getData[i].details[j]);
                    }
                }
                this.financial_array = financial_array;
                //================================================================================
                return this.$store.getters[Const.GET_FINANCIAL_LEDGER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        contract_note_list: function () {
            try {
                return this.$store.getters[Const.GET_CONTRACT_NOTE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        trade_confirmation_list: function () {
            try {
                return this.$store.getters[Const.GET_TRADE_CONFIRMATION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        exchange_list: function () {
            try {
                return this.$store.getters[Const.GET_EXCHANGE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        hold_reason_list: function () {
            try {
                return this.$store.getters[Const.GET_HOLD_REASON_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------view----------------------------------------------
        support_view: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_VIEW];
            }
            catch (ex) {
                return [];
            }
        },
        complaint_otp_view_data: function () {
            try {
                return this.$store.getters[Const.GET_COMPLAINT_OTP_VIEW_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------dropdown--------------------------------------------
        support_reason_list: function () {
            try {
                return this.$store.getters[Const.GET_SUPPORT_REASON_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        bank_list: function () {
            try {
                return this.$store.getters[Const.GET_BANK_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        // nomineeAddJson: function(){
        // 	try{
        // 		return this.$store.getters[Const.GET_NOMINEE_ADD];
        // 	}
        // 	catch(ex){
        // 		return []
        // 	}
        // },
        resident_list: function () {
            try {
                return this.$store.getters[Const.GET_RESIDENT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        account_type_list: function () {
            try {
                return this.$store.getters[Const.GET_ACCOUNT_TYPE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        gender_list: function () {
            try {
                return this.$store.getters[Const.GET_GENDER_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        city_list: function () {
            try {
                return this.$store.getters[Const.GET_CITY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        state_list: function () {
            try {
                return this.$store.getters[Const.GET_STATE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        country_list: function () {
            try {
                return this.$store.getters[Const.GET_COUNTRY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        fatca_country_list: function () {
            try {
                return this.$store.getters[Const.GET_FATCA_COUNTRY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        nationality_list: function () {
            try {
                return this.$store.getters[Const.GET_NATIONALITY_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        matrial_status_list: function () {
            try {
                return this.$store.getters[Const.GET_MARTIAL_STATUS_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        segment_list: function () {
            try {
                return this.$store.getters[Const.GET_SEGMENT_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        address_type_list: function () {
            try {
                return this.$store.getters[Const.GET_ADDRESS_TYPE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        address_proof_list: function () {
            try {
                return this.$store.getters[Const.GET_ADDRESS_PROOF_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        categorization_data_through_ticket: function () {
            try {
                return this.$store.getters[Const.GET_CATEGORIZATION_DATA_THROUGH_TICKET];
            }
            catch (ex) {
                return [];
            }
        },
        address_change_list: function () {
            try {
                return this.$store.getters[Const.GET_ADDRESS_CHANGE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        platform_list: function () {
            try {
                return this.$store.getters[Const.GET_PLATFORM_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        income_list: function () {
            try {
                return this.$store.getters[Const.GET_INCOME_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        occupation_list: function () {
            try {
                return this.$store.getters[Const.GET_OCCUPATION_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        trade_experience_list: function () {
            try {
                return this.$store.getters[Const.GET_TRADE_EXPERIENCE_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        categorization_list: function () {
            try {
                return this.$store.getters[Const.GET_CATEGORIZATION_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        kra_address_proof_list: function () {
            try {
                return this.$store.getters[Const.GET_KRA_ADDRESS_PROOF_LIST];
            }
            catch (ex) {
                return [];
            }
        },
        //-------------------------------------------document Url--------------------------------------------
        contract_note_document_url: function () {
            try {
                return this.$store.getters[Const.GET_CONTRACT_NOTE_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        esign_adhar_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_ESIGN_ADHAR_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        esign_adhar_doc_url_user: function () {
            try {
                return this.$store.getters[Const.GET_ESIGN_ADHAR_DOCUMENT_URL_USER];
            }
            catch (ex) {
                return [];
            }
        },
        view_ticket_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_VIEW_TICKET_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        tax_report_download_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_TAX_REPORT_DOWNLOAD_DOCUMENT_URL];
            }
            catch (ex) {
                return [];
            }
        },
        view_ticket_email_mobile_doc_url: function () {
            try {
                return this.$store.getters[Const.GET_VIEW_TICKET_EMAIL_MOBILE_DOC_URL];
            }
            catch (ex) {
                return [];
            }
        },
        reasonwise_ticket: function () {
            try {
                return this.$store.getters[Const.GET_REASON_TICKET];
            }
            catch (ex) {
                return [];
            }
        },
        scratch_coupon: function () {
            try {
                return this.$store.getters[Const.GET_SCRATCH_COUPON];
            }
            catch (ex) {
                return [];
            }
        },
        portfolio_list: function () {
            try {
                return this.$store.getters[Const.GET_PORTFOLIO_LIST_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        dashbaord_stats_ms: function () {
            try {
                return this.$store.getters[Const.GET_DASHBOARDSTATS];
            }
            catch (ex) {
                return [];
            }
        },
        portfolio_list_amount: function () {
            try {
                return this.$store.getters[Const.GET_PORTFOLIO_LIST_DATA_AMOUNT];
            }
            catch (ex) {
                return [];
            }
        },
        nomineeList: function () {
            try {
                return this.$store.getters[Const.GET_CLIENT_NOMINEE_DATA];
            }
            catch (ex) {
                return [];
            }
        },
        //----------------------------------------------------------leverage json---------------------------------
        leverage_list: function () {
            try {
                var l_json = this.$store.getters[Const.GET_LEVERAGE_JSON][0];
                var leverage_array = [];
                var leverage_array_final = [];
                for (var j = 0; j <= 10; j++) {
                    for (var i = 0; i <= 5; i++) {
                        leverage_array.push(l_json[i][j]);
                        if (i == 5) {
                            leverage_array_final.push(leverage_array);
                            leverage_array = [];
                        }
                    }
                }
                return leverage_array_final;
            }
            catch (ex) {
                return [];
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/prism/index.ts
// module id = null
// module chunks = 